import React, { Component } from 'react';
import { connect } from "react-redux";
import qs from 'qs';
import route_helper from '../../route-helper';

import ActivityIndicator from "../activity-indicator";
import ErrorSummary from "../error-summary";
import api_auth from '../../api/authentication';

import * as action_auth from '../../store/session/actions';
import { save_risk_settings } from '../../store/patient/actions';
import Cookie from 'js-cookie'
import settings from "../../configs/settings";

import {
  save_login_data
} from '../../helpers/helper-login';

class OAuthLogin extends Component {

    constructor(props) {
      super(props);
      this.state = {
        errorMessages: [],
      };

      this.authenticateSSO = this.authenticateSSO.bind(this);
      this.handleLoginFail = this.handleLoginFail.bind(this);
      this.handleLoginSuccess = this.handleLoginSuccess.bind(this);
      this.navigatOauthUser = this.navigatOauthUser.bind(this);
    }
    async componentDidMount() {
        await this.authenticateSSO()
        this.mounted = true
      }

    async componentWillUnmount() {
      this.mounted = false;
    }

    async authenticateSSO(){
        this.setState({loading: true})
        api_auth.clearTokens();

        try{
          let query = qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true
          })

          if(query['state'] !==  Cookie.get('OAuth')) return
          let payload = await api_auth.verify_oauth(query['code'], query['state'])

          save_login_data(this.props.session.user, payload, this.props.dispatch);
          this.props.dispatch(action_auth.authenticated(true));
          this.handleLoginSuccess(payload.organization.org_type);

        } catch (error) {
            this.handleLoginFail('Error logging in. Contact your administrator.')
        } finally {
          if(this.mounted) {
            this.setState({ loading: false });
          }
        }
    }

    handleLoginSuccess(account_type) {
        Cookie.remove('OAuth');
        let is_emr_session = sessionStorage.getItem('is_emr_session')
        if(is_emr_session){
          this.navigatOauthUser()
          return
        }
        if(!is_emr_session && account_type === settings.app_constants.famhisOrg.value) {
          this.navigateToPage(route_helper.administrative.fh_dashboard);
        } else if(!is_emr_session) {
          this.navigateToPage(route_helper.query.query_root);
        }
      }

    handleLoginFail(error) {
      this.setState({errorMessages: [error]});
    }

    navigateToPage(path) {
        const { from } = this.props.location.state || { from: { pathname: path } };
        this.props.history.replace(from);
      }

    navigatOauthUser(){
      let firstName = localStorage.getItem('fname')
      let lastName = localStorage.getItem('lname')
      let dob = localStorage.getItem('dob')
      let mrn = localStorage.getItem('finalMrn')
      let encryptedData = localStorage.getItem('encryptedData')
      let signature = localStorage.getItem('signature')
    
      if(encryptedData && signature){
        this.props.history.push(`/emr_patients?fname=${firstName}&lname=${lastName}&dob=${dob}&mrn=${mrn}&data=${encryptedData}&signature=${signature}`);
      }else { 
        this.props.history.push(`/emr_patients?fname=${firstName}&lname=${lastName}&dob=${dob}&mrn=${mrn}`);
      }
    }

    render() {
      const copyright_year = new Date().getFullYear();
      return (
        <React.Fragment>
          <div className="login_wrapper">
            <div className="animate form login_form">
              <section className="login_content">
                <ErrorSummary errorMessages={this.state.errorMessages} />
                  <div className="animate form login_form">
                    <div><p className="text-center text-muted margin-nine-top"><span>&copy; {copyright_year} by FamHis, Inc. All rights reserved.</span></p></div>
                  </div>
              </section>
            </div>
          </div>
        <ActivityIndicator loading={this.state.loading} />

        </React.Fragment>
      );
    }
  }
  const redux_state = state => ({
    session: state.session
  });

  const redux_actions = dispatch => ({
    dispatch: (action) => dispatch(action)
  });

  export default connect(redux_state, redux_actions)(OAuthLogin);
